import type { FieldType, SchemaField } from '@cli-types/core-engine/schema.js'

export function createAutoField(name: string, type: FieldType): SchemaField {
  return {
    name,
    type,
    required: true
  }
}
